export const getSpaceSidebarBadgeCount = (
  unreadContentCount: number,
  unreadNotificationsCount: number,
): string => {
  if (unreadNotificationsCount > 0) {
    return String(unreadNotificationsCount);
  }
  if (unreadContentCount > 99) {
    return "99+";
  }
  return String(unreadContentCount);
};
